import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

export const usePageView = (pageTitle: string) => {
  const location = useLocation();

  useEffect(() => {
    if (!window.gtag) return;

    window.gtag('event', 'page_view', {
      page_path: location.pathname + location.search,
      page_title: pageTitle,
      environment: import.meta.env.MODE,
    });
  }, [location.pathname, location.search]);
};
